import * as React from 'react';
import { TextareaAutosize } from '@mui/material';

export const CustomTextArea = ({
  value,
  name,
  onChange,
  minRows = 3,
  maxRows = 5,
  placeholder,
  width = '100%',
}) => {
  const [localValue, setLocalValue] = React.useState(value);

  React.useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = (e) => {
    onChange(e);
  };

  return (
    <TextareaAutosize
      className="custom-textarea"
      maxRows={maxRows}
      minRows={minRows}
      aria-label={name}
      name={name}
      value={localValue}
      placeholder={placeholder}
      onChange={handleChange}
      onBlur={handleBlur}
      style={{ width }}
    />
  );
};